import { useSelector } from 'react-redux';

import { useAppDispatch } from '@store/hooks/useAppDispatch';
import { useFetch } from '@api/hooks';
import type { DashboardOverallRequest, DashboardOverallResponse } from '@api/domain/types';
import { DashboardRequestType } from '@api/domain/types';
import { selectDashboardOverall } from '@reducers/v2/dashboard/dashboard.slice';
import { fetchDashboardOverall } from '@reducers/v2/dashboard/thunks';

interface UseGetDashboardOverallParams extends Omit<DashboardOverallRequest, '$type'> {
  enabled?: boolean;
}

export const useGetDashboardOverall = ({ scope, resultType, from, to, drilldownFilter, enabled = true }: UseGetDashboardOverallParams) => {
  const dispatch = useAppDispatch();
  const { data, loading: storeLoading, error } = useSelector(selectDashboardOverall);

  const { loading, refetch } = useFetch<DashboardOverallResponse | null>({
    fetchFn: async (signal) => {
      if (!enabled) return null;
      const result = await dispatch(
        fetchDashboardOverall({
          params: {
            $type: DashboardRequestType.Overall,
            scope,
            resultType,
            from,
            to,
            drilldownFilter,
          },
          signal,
        })
      ).unwrap();
      return result ?? null;
    },
    deps: [enabled, scope, resultType, from, to, drilldownFilter?.$type],
  });

  return { data, loading: loading || storeLoading, error, refetch };
};
